'use strict';

angular.module('clientDashboardApp').directive('naIf',function(){
  return {
    restrict: 'A',
    scope: {
      naIf: "="
    },
    transclude: true,
    template: `<span ng-if="!naIf"><ng-transclude></ng-transclude></span>
               <span ng-if="naIf">N/A</span>`
  }
})
